"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColumns = void 0;
var _react = _interopRequireDefault(require("react"));
var _ActivityCellComponents = require("../components/RecentActivity/ActivityCellComponents");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var getColumns = exports.getColumns = function getColumns(width, themeModifier, t) {
  var columns = [{
    header: t('Action'),
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.Action, _extends({
        showProductIcon: true,
        themeModifier: themeModifier
      }, row));
    }
  }, {
    header: t('Amount'),
    width: '20rem',
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.Amount, row);
    }
  }, {
    header: t('Status / ID'),
    width: '40rem',
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.Status, row);
    }
  }, {
    header: t('Time & Date'),
    width: '15rem',
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.DateTime, row);
    }
  }];
  return columns;
};